import React from 'react';

import { ADMIN_OUTBOX } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { EmailOutboxIcon } from '@Generic/icons';

const OutboxPage = React.lazy(() => import('../../../pages/Admin/Outbox/OutboxPage'));

export default {
  label: 'navigation.admin.outbox',
  group: ADMIN,
  to: '/administration/outbox',
  route: '/administration/outbox',
  component: OutboxPage,
  icon: <EmailOutboxIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_OUTBOX,
  area: ADMIN_OUTBOX,
  hasNavBar: true,
};
